import {createSinglePathSVG} from './TEMPLATE'

/**
 * Paperclip, exported directly from Figma (node 63:701, file
 * pxYtWNgjV2VOLMGYr0ujlL) for the cover-image "Change cover image" menu
 * item. No existing library icon matches - `Clipboard`/`VideoClip` are a
 * clipboard and a film clip respectively, neither a paperclip.
 */
export const Attachment01 = createSinglePathSVG({
  path: 'M14.1017 7.26633L8.09126 13.2767C6.72443 14.6436 4.50835 14.6436 3.14152 13.2767C1.77468 11.9099 1.77468 9.69382 3.14152 8.32699L9.15192 2.31658C10.0631 1.40536 11.5405 1.40536 12.4518 2.31658C13.363 3.22781 13.363 4.70519 12.4518 5.61641L6.67705 11.3911C6.22144 11.8467 5.48275 11.8467 5.02713 11.3911C4.57152 10.9355 4.57152 10.1968 5.02713 9.7412L10.0947 4.6736',
  viewBox: '0 0 16 16',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
})
